export default import.meta.ROLLDOWN_FILE_URL_A1Y0wHGMHMn7kvWJCu_Mig